var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("el-input", {
        staticClass: "hide",
        attrs: {
          autocomplete: "new-password",
          placeholder: _vm.$t.__("common.labels.address_name")
        },
        model: {
          value: _vm.currentValue.name,
          callback: function($$v) {
            _vm.$set(_vm.currentValue, "name", $$v)
          },
          expression: "currentValue.name"
        }
      }),
      _vm._v(" "),
      _vm.currentValue.manualMode
        ? _c(
            "div",
            [
              _vm._t(
                "manualAddress",
                [
                  _c(
                    "el-form-item",
                    { staticClass: "mt-2", attrs: { prop: "line1" } },
                    [
                      _c("el-input", {
                        attrs: {
                          autocomplete: "off",
                          placeholder: _vm.$t.__("common.labels.street")
                        },
                        model: {
                          value: _vm.currentValue.line1,
                          callback: function($$v) {
                            _vm.$set(_vm.currentValue, "line1", $$v)
                          },
                          expression: "currentValue.line1"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { staticClass: "mt-2" },
                    [
                      _c("el-input", {
                        attrs: {
                          autocomplete: "off",
                          placeholder: _vm.$t.__(
                            "inputs.custom.Address.building_floor"
                          )
                        },
                        model: {
                          value: _vm.currentValue.line2,
                          callback: function($$v) {
                            _vm.$set(_vm.currentValue, "line2", $$v)
                          },
                          expression: "currentValue.line2"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { staticClass: "mt-2" },
                    [
                      _c("el-input", {
                        attrs: { autocomplete: "off" },
                        model: {
                          value: _vm.currentValue.line3,
                          callback: function($$v) {
                            _vm.$set(_vm.currentValue, "line3", $$v)
                          },
                          expression: "currentValue.line3"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { staticClass: "mt-2" },
                    [
                      _c("el-input", {
                        attrs: { autocomplete: "off" },
                        model: {
                          value: _vm.currentValue.line4,
                          callback: function($$v) {
                            _vm.$set(_vm.currentValue, "line4", $$v)
                          },
                          expression: "currentValue.line4"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { staticClass: "mt-2", attrs: { prop: "postalCode" } },
                    [
                      _c("el-input", {
                        attrs: {
                          autocomplete: "off",
                          placeholder: _vm.$t.__("common.labels.postal_code")
                        },
                        model: {
                          value: _vm.currentValue.postalCode,
                          callback: function($$v) {
                            _vm.$set(_vm.currentValue, "postalCode", $$v)
                          },
                          expression: "currentValue.postalCode"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { staticClass: "mt-2", attrs: { prop: "city" } },
                    [
                      _c("el-input", {
                        attrs: {
                          autocomplete: "off",
                          placeholder: _vm.$t.__("common.labels.city")
                        },
                        model: {
                          value: _vm.currentValue.city,
                          callback: function($$v) {
                            _vm.$set(_vm.currentValue, "city", $$v)
                          },
                          expression: "currentValue.city"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { staticClass: "mt-2", attrs: { prop: "country" } },
                    [
                      _c("country-input", {
                        attrs: {
                          "default-value": {
                            code: _vm.currentValue.countryCode,
                            name: _vm.currentValue.country
                          }
                        },
                        on: { change: _vm.updateCountry }
                      })
                    ],
                    1
                  )
                ],
                { data: _vm.currentValue, updateCountry: _vm.updateCountry }
              )
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm._t(
        "algoliaWrapper",
        [
          _c(
            "div",
            { class: { hide: _vm.currentValue.manualMode } },
            [
              _c("algolia-input", {
                attrs: {
                  "element-name": _vm.value._id,
                  "place-type": "address"
                },
                on: { "bubble-address": _vm.captureAddress }
              }),
              _vm._v(" "),
              _c("CompassPlainButton", {
                staticClass: "mt-1 b-0 pl-0",
                attrs: { label: _vm.manuallyLabel },
                on: { click: _vm.switchMode }
              })
            ],
            1
          )
        ],
        {
          methods: {
            captureAddress: _vm.captureAddress,
            switchMode: _vm.switchMode
          },
          props: _vm.$props,
          data: _vm.$data
        }
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }